import React from "react";
import "./styles/App.css";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Route, Routes, BrowserRouter, Link } from "react-router-dom";

import Home from "./pages/Home";
import About from "./pages/About";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import Services from "./pages/Services";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import Resume from "./pages/Resume";
import Timeline from "./pages/Timeline";
import Contact from "./pages/Contact";
import Portfolio from "./pages/Portfolio";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <header className="header">
                    <div className="aboutMe">
                        <div className="menu">
                            <a className="logo" href="https://www.amyyqlin.com/" rel="noopener noreferrer">
                                AMY Y.Q. LIN
                            </a>
                            <br />
                            <div className="menuOptions">
                                <Link to="/about">
                                    <button className="menuItem">About</button>
                                </Link>
                                <Link to="/timeline">
                                    <button className="menuItem">Timeline</button>
                                </Link>
                                {/* <Link to="/services">
                                    <button className="menuItem">Services</button>
                                </Link> */}
                                {/* <Link to="/resume">
                                    <button className="menuItem">Resume</button>
                                </Link> */}
                                <Link to="/portfolio">
                                    <button className="menuItem">Gaming</button>
                                </Link>
                                <Link to="/contact">
                                    <button className="menuItem">Contact</button>
                                </Link>
                            </div>
                        </div>

                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/timeline" element={<Timeline />} />
                            {/* <Route path="/services" element={<Services />} />
                            <Route path="/resume" element={<Resume />} /> */}
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/portfolio" element={<Portfolio />} />
                        </Routes>
                    </div>
                </header>
            </BrowserRouter>
        </div>
    );
}

export default App;
